import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.333 8.333v-5a.666.666 0 0 0-.666-.666H3.333a.666.666 0 0 0-.666.666v9.334a.666.666 0 0 0 .666.666h5a.667.667 0 0 1 .135 1.32l-.135.014h-5a2 2 0 0 1-2-2V3.333a2 2 0 0 1 2-2h9.334a2 2 0 0 1 2 2v5a.667.667 0 0 1-1.334 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m14 6 .135.013a.667.667 0 0 1 0 1.307L14 7.334H2A.667.667 0 0 1 2 6z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6 14V2a.667.667 0 0 1 1.334 0v12A.667.667 0 0 1 6 14M14.667 12l.134.013a.668.668 0 0 1 0 1.307l-.134.014h-4a.667.667 0 0 1 0-1.334z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 14.667v-4a.667.667 0 0 1 1.334 0v4a.667.667 0 0 1-1.334 0"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })